module.exports = __webpack_public_path__ + "static/media/foundpets.072acfa8.png";